import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { QuotationsVersion } from '../Quotations.contracts';
import { QuotationsVersionModule } from './Quotations.abstract';
import { BootstrapBadge, BootstrapImage, BootstrapLink } from '../../../dsl/bootstrap';
let Personal = class Personal extends QuotationsVersionModule {
    constructor() {
        super(...arguments);
        this.inViewObserver = null;
    }
    getLabelName(item) {
        var _a;
        const labels = (_a = item.article) === null || _a === void 0 ? void 0 : _a.properties.labels;
        if (labels && Array.isArray(labels) && labels.length > 0) {
            return labels[0].name;
        }
        return null;
    }
    initInViewObserver() {
        if (!this.containerRef) {
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                e.target.classList.toggle('--in-view', e.intersectionRatio === 1);
            });
        }, { threshold: [1], root: this.containerRef });
        this.containerRef.querySelectorAll('.quotations__list__item').forEach(item => {
            observer.observe(item);
        });
        this.inViewObserver = observer;
    }
};
Personal.moduleVersion = QuotationsVersion.Personal;
Personal = __decorate([
    Component({
        name: 'Personal',
        components: { BootstrapBadge, BootstrapLink, BootstrapImage },
        template: `
    <div v-show="active" class="quotations__list__wrap">
      <button class="quotations__list__arrow quotations__list__arrow--prev" :class="{ '--visible': isPrevVisible }" @click="goPrev">
        <D24Icon name="chevron-left" size="small" />
      </button>

      <div class="quotations__list quotations__list--personal" :class="{ '--is-dragged': isDragged }" ref="container">
        <div v-for="item in items" :key="item.id" class="quotations__list__item --in-view">
          <BootstrapBadge v-if="getLabelName(item)" class="quotations__list__item__badge">
            {{ getLabelName(item) }}
          </BootstrapBadge>
          <div class="quotations__list__item__text" v-html="demarkedContent(item)" />
          <div class="quotations__list__item__author">{{ item.authorName }}</div>

          <BootstrapLink :link="{ target: item.article?.urlPath }" class="stretched-link" draggable="false" />
        </div>
      </div>

      <button class="quotations__list__arrow quotations__list__arrow--next" :class="{ '--visible': isNextVisible }" @click="goNext">
        <D24Icon name="chevron-right" size="small" />
      </button>
    </div>
  `,
        mounted() {
            this.initInViewObserver();
        },
        beforeDestroy() {
            if (this.containerRef) {
                this.containerRef.querySelectorAll('.quotations__list__item').forEach(item => {
                    if (this.inViewObserver) {
                        this.inViewObserver.unobserve(item);
                    }
                });
            }
        }
    })
], Personal);
export { Personal };
